import React, { Component } from 'react';
import styled from 'styled-components';

import { Text } from '../common/Text';
import ProgressBar from '../../components/common/WaterProgressBar';
import {
  addWater,
  getWaterLogDetails,
  removeWater,
} from '../../services/water-log';

import WaterIcon from '../../images/home/water_logo.svg';
import WaterLogMinus from '../../images/home/water_glass_minus_filled.png';
import WaterLogPlus from '../../images/home/water_glass_plus_filled.png';
import ViewDoc from '../../images/home/view_details_doc.svg';

const OuterTappable = styled.button`
  margin: 0.4rem 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  background: #ffffff;
  border-radius: 12px;
  width: 90%;
  margin-left: 5%;
`;

const OuterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 16px;
  padding-right: 24px;
`;

const TitleContainer = styled.div`
  display: flex;
  flex: 2;
  flex-direction: column;
  align-items: stretch;
`;

const TitleText = styled(Text)`
  float: left;
  color: #21243c;
  margin-left: 12px;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 150%;
  display: inline-block;
  color: #21243c;
`;

const WaterLogContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 16px 32px;
  padding-bottom: 20px;
`;

const ProgressContainer = styled.div`
  width: 50%;
  top: 42px;
  position: absolute;
  margin-left: 25%;
  margin-right: 15%;
  height: 20px;
`;

const Tags = styled.p`
  color: #21243c;
  font-size: 12px;
  text-align: center;
  font-weight: 600;
  margin-top: 4px;
`;

const ViewDetails = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  color: var(--primary-button);
  font-weight: 600;
  border-top: 1px solid #f0f3f6;
  font-size: 12px;
`;

const ModifyContainer = styled.div``;

export default class WaterLogCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      goal: 0,
      addLabel: null,
      removeLabel: null,
      vesselGoal: 0,
      selectedVesselKey: null,
      addVeselIcon: null,
      removeVeselIcon: null,
      goalPercentage: 0,
    };
  }

  componentDidMount() {
    this.getWaterLogDetails();
  }

  getWaterLogDetails = () => {
    getWaterLogDetails(this.props.authToken)
      .then((response) => {
        const data = response.data;
        const loggingCard = data.loggingCard;
        const {
          goal,
          addLabel,
          removeLabel,
          selectedVesselKey,
          vesselGoal,
          goalPercentage,
          goalLabel,
        } = loggingCard;
        this.setState({
          goal,
          addLabel,
          removeLabel,
          selectedVesselKey,
          vesselGoal,
          goalPercentage,
          goalLabel,
        });
      })
      .catch((err) => {
        console.error(err);
      });
  };

  decreaseWater = () => {
    removeWater(this.props.authToken)
      .then((response) => {
        const data = response.data;
        this.setState({
          addLabel: data.addLabel,
          removeLabel: data.removeLabel,
          goalPercentage: data.goalPercentage,
          vesselGoal: data.vesselGoal,
        });
      })
      .catch((err) => {
        console.error(err);
      });
  };

  increaseWater = (e) => {
    e.stopPropagation();

    addWater(this.props.authToken)
      .then((response) => {
        const data = response.data;
        this.setState({
          addLabel: data.addLabel,
          removeLabel: data.removeLabel,
          goalPercentage: data.goalPercentage,
          vesselGoal: data.vesselGoal,
        });
      })
      .catch((err) => {
        console.error(err);
      });
  };

  render() {
    const {
      goal,
      addLabel,
      removeLabel,
      vesselGoal,
      goalPercentage,
      goalLabel,
    } = this.state;
    return (
      <OuterTappable className="rounded-12 border border-txtsecondary-shades7">
        <OuterContainer>
          <TitleContainer
            className="flex justify-between w-full mb-4px mt-18px"
            style={{ flexDirection: 'row', alignItems: 'center' }}
          >
            <div className="flex">
              <img src={WaterIcon} alt="" width={'20px'} height={'20px'} />
              <TitleText>Water Log</TitleText>
            </div>
          </TitleContainer>
        </OuterContainer>
        <div className="relative pt-6px pb-10px">
          <WaterLogContainer>
            <ModifyContainer
              className="clickable"
              onClick={(e) => {
                e.stopPropagation();
                if (removeLabel != '0ml') {
                  this.decreaseWater();
                }
              }}
            >
              <img src={WaterLogMinus} alt="" width={'50px'} height={'50px'} />
              <Tags>{removeLabel}</Tags>
            </ModifyContainer>
            <div>{/* <ProgressBar width={`${100}%`} /> */}</div>
            <ModifyContainer
              className="clickable"
              onClick={(e) => {
                e.stopPropagation();
                this.increaseWater(e);
              }}
            >
              <img src={WaterLogPlus} alt="" width={'50px'} height={'50px'} />
              <Tags>{addLabel}</Tags>
            </ModifyContainer>
          </WaterLogContainer>
          <ProgressContainer>
            <ProgressBar
              width={`${
                goalPercentage <= 1 ? Math.floor(goalPercentage * 100) : 100
              }%`}
            />
            <Tags
              style={{
                textAlign: 'center',
                color: '#47464a',
                marginTop: '20px',
                fontSize: '12px',
              }}
            >
              Goal : <span className="font-bold">{goalLabel}</span>{' '}
              <span className="mx-16px text-borderColor text-card-body">|</span>
              <span>{vesselGoal}</span> Glasses
            </Tags>
          </ProgressContainer>
        </div>
        <div
          onClick={() => this.props.history.push('/water-details')}
          className=" flex border-t border-txtsecondary-shades7 items-center justify-center gap-1 clickable text-primary text-body-l font-semibold py-3"
        >
          <img
            src={ViewDoc}
            alt="view_doc"
            width="24px"
            style={{ marginRight: '4px' }}
          />
          View Details
        </div>
      </OuterTappable>
    );
  }
}
